import { Status } from '@docma-mm-core/status/status';
import {FaultExportAttachmentTypesEnum} from '../../mm-faults/mm-faults-export/fault-export-attachment-types.enum';
export class Shortcut {
    Id?: number;
    Symbol?: number;
    Status?: Status;
    Description?: string;
    IconName?: string;

    constructor(init?: Partial<Shortcut>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}

export function getShortcutIconName(shortcut: Shortcut) {
    return ShortcutIcons[shortcut.Symbol];
}

const ShortcutIcons: { [Symbol: number]: string } = {
    [0]: '_checked',
    [1]: '_unavailable',
    [2]: '_chat-bubble',
    [3]: '_info',
    [4]: '_error',
};
